module.exports = __webpack_public_path__ + "static/Roche_logo-f8427c50af5fdb7a90bf26535ff9da21.png";